import { Component, OnInit } from '@angular/core';
import { Grid } from '../../../core/components/grid/grid.model';
import { GridOptions } from '../../../core/components/grid/grid.types';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-sub-operations',
  templateUrl: './sub-operations.component.html',
  styleUrls: ['./sub-operations.component.css']
})
export class SubOperationsComponent implements OnInit {
    operationId;

    public setting?: Setting;

    public grid?: GridOptions;

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.operationId = this.stateService.getStateParams()['operation_id'];
    }

    private async loadSetting() {
        if (!!this.operationId) {
            this.setting = (await this.datatask.Post(2462, { operation_id: this.operationId }))[0];
        }
    }

    private loadGrid() {
        if (!this.setting) return;

        if (!this.grid) {
            this.grid = new Grid()
                .setRememberId(this.setting.view_id)
                .setLoadDataFunction({
                    method: this.setting.p2_datatask_keyno,
                    parameters: () => this.setting
                })
                .setKendoConfig({ height: '100%' })
                .setToolbar({ wrapping: true })
                .setCustomToolbarButtons([{
                    name: 'suboperations_new',
                    text: 'suboperations_new',
                    tooltip: 'suboperations_new',
                    translateTooltip: true,
                    func: () => this.stateService?.go('suboperation', {
                        operation_id: this.setting!.operation_id,
                        suboperation_keyno: '0'
                    }),
                    icon: 'fas fa-plus',
                    cssClass: 'tt-button tt-button--primary im-grid-btn-xs-r',
                    translate: true
                }]);
        } else {
            this.grid?.gridfunc?.read();
        }
    }

    private async init() {
        await this.loadSetting();
        this.loadGrid();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    operation_id: string;
    p2_datatask_keyno: number;
    view_id: string;
}
